// extracted by css-extract-rspack-plugin
export default {"tableRowSpacing":"RZ7Jh","dataPointTable":"uSEux","dataPointTableBody":"jBIev","dataPointTableFooter":"Bth_b"};